const storageCart = JSON.parse(localStorage.getItem('cartItems'));
if (storageCart && storageCart.length > 0) {
  const dataCart = storageCart.map((data) => {
    if (data.selling_plan_allocation != null) {
      return (
        {
          quantity: data.quantity,
          id: data.id,
          variant_id: data.variant_id,
          properties: data.properties,
          product_id: data.product_id,
          selling_plan: data.selling_plan_allocation.selling_plan.id,
        } || []
      );
    }
    return (
      {
        quantity: data.quantity,
        id: data.id,
        variant_id: data.variant_id,
        properties: data.properties,
        product_id: data.product_id,
      } || []
    );
  });

  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    data: { items: dataCart },
    success: function (json) {
      localStorage.removeItem('cartItems');
      location.reload();
    },
    error: function (xhr, textStatus, errorThrown) {
      localStorage.removeItem('cartItems');
      location.reload();
    },
    dataType: 'json',
  });
}
